export const TypeOfPlanList = [
  {
    id: 1,
    label: 'Single activity',
  },
  {
    id: 2,
    label: 'Multiple activities',
  },
  {
    id: 3,
    label: 'Plan of activities',
  },
];

export const TypeOfPlanConst = {
  SINGLE_ACTIVITY: 1,
  MULTIPLE_ACTIVITIES: 2,
  PLAN_OF_ACTIVITIES: 3,
};
